<template>
  <v-container class="mesh-result text-xs-center">
    <!-- <model-obj src="https://people.sc.fsu.edu/~jburkardt/data/obj/airboat.obj"></model-obj> -->
    <model-obj :src="mesh"></model-obj>
  </v-container>
</template>

<script>
import { ModelObj } from 'vue-3d-model';
export default {
  props: ['mesh'],
  components: {
    ModelObj
  }
}
</script>
